import { api, types } from "api";
import { InfoSnackBar } from "components/InfoSnackBar";
import { Route } from "components/Route";
import { GROUP_DISPLAY_ERROR } from "messages";
import { useEffect, useState } from "react";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { CreateGroupPage } from "./CreateGroup";
import { NoGroupsPage } from "./NoGroupsPage";
import { ViewGroupsPage } from "./ViewGroupsPage";

export const GroupManagementSwitch = (): JSX.Element => {
	// The value of `groupsFresh` is not important. It is only used to force a
	// fresh request for groups.
	const [groupsFresh, setGroupsFresh] = useState(false);
	const toggleGroupsFresh = (): void => setGroupsFresh((f) => !f);

	// null indicates that no requests have been made
	const [groups, setGroups] = useState<types.Group[] | null>(null);
	const [err, setErr] = useState(false);

	useEffect(() => {
		api
			.getGroups()
			.then((res) => {
				if (res.status !== 200) {
					setErr(true);
					return;
				}

				setErr(false);

				// The following is a workaround for
				// https://linear.app/science-island/issue/SI-126
				if (res.data === null) {
					return;
				}

				if (res.data.length === 0) {
					setGroups([]);
					return;
				}

				setGroups(res.data);
			})
			.catch(() => setErr(true));
	}, [groupsFresh]);

	// This avoids flashing the `NoGroupsPage` while the request is being made.
	let groupsPage: JSX.Element | null = null;
	if (Array.isArray(groups)) {
		groupsPage =
			groups.length === 0 ? (
				<NoGroupsPage />
			) : (
				<ViewGroupsPage groups={groups} setGroups={setGroups} />
			);
	}

	return (
		<Switch>
			<Route path={routes._.groups._.create.path}>
				<CreateGroupPage toggleGroupsFresh={toggleGroupsFresh} />
			</Route>

			<Route path={routes._.groups.path}>
				{groupsPage}

				{/* Shows error if `getGroups` fails. */}
				<InfoSnackBar
					isOpen={err}
					onClose={() => setErr(false)}
					message={GROUP_DISPLAY_ERROR}
					severity="error"
				/>
			</Route>
		</Switch>
	);
};
